import { useQuery } from '@tanstack/react-query';
import { useLocation } from '@/shared/hooks/useLocation';
import { callsApi } from '../api/callsApi';
import { callsKeys } from '../queryKeys';

export function useCallStats() {
  const { currentLocation } = useLocation();
  const locationId = currentLocation?.id ?? '';

  return useQuery({
    queryKey: callsKeys.stats(locationId),
    queryFn: () => callsApi.getStats(locationId),
    enabled: !!locationId,
    staleTime: 60 * 1000,
  });
}
